import { render, staticRenderFns } from "./CakeAddressList.vue?vue&type=template&id=fa1e2674&scoped=true"
import script from "./CakeAddressList.vue?vue&type=script&lang=js"
export * from "./CakeAddressList.vue?vue&type=script&lang=js"
import style0 from "./CakeAddressList.vue?vue&type=style&index=0&id=fa1e2674&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1e2674",
  null
  
)

export default component.exports